var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "clockFace",
      staticClass: "clock-face",
      style: { width: _vm.clockSize + "px", height: _vm.clockSize + "px" },
      on: {
        mousedown: _vm.handlePointerDown,
        touchstart: _vm.handlePointerDown
      }
    },
    [
      _c("div", { staticClass: "clock-face__center" }),
      _c(
        "svg",
        {
          staticClass: "clock-face__selector",
          attrs: { width: _vm.clockSize, height: _vm.clockSize }
        },
        [
          _c("line", {
            attrs: {
              x1: _vm.center,
              y1: _vm.center,
              x2: _vm.selectorEndX,
              y2: _vm.selectorEndY,
              stroke: "var(--primary)",
              "stroke-width": "2"
            }
          }),
          _c("circle", {
            attrs: {
              cx: _vm.selectorEndX,
              cy: _vm.selectorEndY,
              r: "16",
              fill: "var(--primary)",
              opacity: "0.15"
            }
          })
        ]
      ),
      _vm._l(_vm.items, function(item) {
        return _c(
          "div",
          {
            key: _vm.mode + "-" + item.value,
            staticClass: "clock-face__number",
            class: {
              "clock-face__number--selected": _vm.isSelected(item),
              "clock-face__number--inner": item.isInner
            },
            style: { left: item.x + "px", top: item.y + "px" }
          },
          [_vm._v(" " + _vm._s(item.label) + " ")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }